<div class="collapse__section" *ngIf="section">{{ section }}</div>
<div class="collapse__section_info" *ngIf="section_info">{{ section_info }}</div>
<div
  class="app-ph-collapse"
  [id]="anchor ? anchor : ''"
  [ngClass]="{ 'collapse--open': open, 'collapse--opened': opened }"
  #phCollapse
>
  <div class="collapse__header" (click)="toggleCollapse()">
    <p class="header-text">
      {{ title }}<span>{{ info }}</span>
    </p>
    <input type="text" readonly="readonly" class="open-tab-btn" (keyup.tab)="focusElTab($event)" />
    <button class="header-close">
      <i class="zmdi zmdi-chevron-down"></i>
    </button>
  </div>
  <div class="collapse__content">
    <ng-content></ng-content>
  </div>
</div>
